import React, { useState } from "react";
import {
  Button,
  Dialog,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Input,
  Checkbox,
  Select,
  Option,
} from "@material-tailwind/react";
import { canadianProvinces } from "../../utils/constants";
import { isValidEmail } from "../../utils/helpers";
import { AlertCustomStyles } from "../layout/AlertCustomStyles";
import UserService from "../../services/user.service";
import { SpinnerWithInfo } from "../layout/SpinnerWithInfo";
export default function EmailInfoEditorForm({ loggedInUser, onComplete }) {
  const [error, setError] = useState("");
  const [alert, setAlert] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(loggedInUser.email);
  const handleSubmit = () => {
    if (error || !email || !isValidEmail(email)) {
      setAlert("NotComplete");
    } else {
      setAlert("");
      setLoading(true);
    }
  };
  return (
    <>
      <Card className="mx-auto w-full max-w-[24rem] md:p-2">
        {!loading && (
          <>
            <CardBody className="flex flex-col gap-6">
              {alert && alert == "fail" && (
                <AlertCustomStyles
                  status={alert}
                  message={"Updating address failed, try again!"}
                />
              )}
              {alert && alert == "NotComplete" && (
                <AlertCustomStyles
                  status={alert}
                  message={"Invalid email, try again!"}
                />
              )}
              <Typography
                className="mb-1 font-normal font-nunito"
                variant="paragraph"
                color="gray"
              >
                Change Email
              </Typography>
              <Input
                name="email"
                onChange={(e) => setEmail(e.target.value)}
                error={error}
                value={email}
                type="email"
              />
            </CardBody>
            <CardFooter className="pt-0 flex gap-3 m-auto">
              <Button
                variant="button"
                onClick={handleSubmit}
                className=" bg-[#882699] hover:bg-[#cf3be9] normal-case md:text-[15px] text-[12px]"
                size="sm"
              >
                Update
              </Button>
              <Button
                variant="outlined"
                color="red"
                onClick={() => onComplete({ type: "email", result: null })}
                size="sm"
                className="normal-case md:text-[15px] text-[12px]"
              >
                <span>Cancel</span>
              </Button>
            </CardFooter>
          </>
        )}
        {loading && (
          <div className="p-20">
            <SpinnerWithInfo message="Saving changes..." />
          </div>
        )}
      </Card>
    </>
  );
}
